export default class ScrollAnimator {
  constructor() {
    this.elements = document.querySelectorAll('.gr-animate');

    // Creamos dos observadores con diferente rootMargin
    this.fadeObserver = new IntersectionObserver(this.animateOnView.bind(this), {
      threshold: 0,
      rootMargin: '0px 0px -20% 0px', // Fade-in: aparece tarde (como te gustaba)
    });

    this.slideObserver = new IntersectionObserver(this.animateOnView.bind(this), {
      threshold: 0,
      rootMargin: '0px 0px -10% 0px', // Slide-in: aparece antes
    });

    this.init();
  }

  init() {
    this.elements.forEach((el) => {
      if (
        el.classList.contains('slide-in-up') ||
        el.classList.contains('slide-in-left') ||
        el.classList.contains('slide-in-right') ||
        el.classList.contains('slide-in-down')
      ) {
        this.slideObserver.observe(el);
      } else {
        this.fadeObserver.observe(el);
      }
    });
  }

  animateOnView(entries, observer) {
    entries.forEach(entry => {
      const el = entry.target;
      if (entry.isIntersecting) {
        const timeoutClass = [...el.classList].find(cls => cls.startsWith('timeout-'));
        const delay = timeoutClass ? parseInt(timeoutClass.replace('timeout-', '')) * 100 : 0;

        setTimeout(() => {
          el.classList.add('active');
          el.classList.remove('out');
        }, delay);

        observer.unobserve(el);
      } else {
        if (el.classList.contains('fade-out') ||
            el.classList.contains('slide-out-up') ||
            el.classList.contains('slide-out-left') ||
            el.classList.contains('slide-out-right')) {
          el.classList.add('out');
          el.classList.remove('active');
        }
      }
    });
  }
}
